module.exports = __webpack_public_path__ + "static/media/story_13.b617d459.jpg";